"use client"

import * as React from "react"
import * as AvatarPrimitive from "@radix-ui/react-avatar"

import { cn } from "../../../lib/utils"

const Avatar = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> & {
        name?: string;
        size?: 'sm' | 'md' | 'lg';
    }
>(({ className, name, size = 'md', ...props }, ref) => {
    const initials = name
        ? name.split('@')[0].split('.').map(part => part[0]).join('').toUpperCase()
        : '';

    const sizeClasses = {
        sm: 'h-6 w-6 text-xs',
        md: 'h-8 w-8 text-sm',
        lg: 'h-10 w-10 text-base',
    };

    return (
        <AvatarPrimitive.Root
            ref={ref}
            className={cn(
                "relative flex shrink-0 overflow-hidden rounded-full",
                sizeClasses[size],
                className
            )}
            {...props}
        >
            <AvatarPrimitive.Fallback
                className="flex h-full w-full items-center justify-center rounded-full bg-indigo-100 text-indigo-600 font-medium"
            >
                {initials}
            </AvatarPrimitive.Fallback>
        </AvatarPrimitive.Root>
    )
})
Avatar.displayName = AvatarPrimitive.Root.displayName

export { Avatar }